<template>
  <div class="missjones-class pb-5 px-4 pt-4">
    <div class="pr-[20px]">
      <block-loading v-if="loading"/>

      <template v-else>
        <div>
            <h1 class="text-white mt-3 font-semibold text-[24px]  break-all">{{ form.name.value }}</h1>
            <a v-if="domain" :href="getDomainUrl()" target="_blank" class="text-theme-green text-xs font-normal tracking-wider underline">{{getUrl()}}</a>
            <span class="text-xs font-normal tracking-wider " v-else>{{getUrl()}}</span>
        </div>
        <div class="pt-3">
            <div class="flex gap-3 xl:flex-row flex-col items-start mb-3">
                <div class="w-full xl:w-1/2">
                    <div :class="'input-wrapper ' + (form.name.error_type)">
                        <label class="text-xs mb-1">Name</label>
                        <input placeholder="Miss Jones North York" v-model="form.name.value" @keyup="validateFields(['name'])" class="block border-none rounded bg-gray-black w-full text-sm text-white placeholder-borderblack" type="text">
                        <p class="field-error label-text mt-1" v-if="form.name.error_message" v-text="form.name.error_message"></p>
                    </div>
                </div>
                <div class="w-full xl:w-1/2">
                    <div :class="'input-wrapper ' + (form.businessBrandProfileId.error_type)">
                        <label class="text-xs mb-1">Brand Profile</label>
                        <SelectSearchBrand
                            :disabled="!can_edit_business_brand_profiles"
                            v-model="form.businessBrandProfileId.value"
                            :options="businessProfiles"
                            placeholder="No Profile"
                            class="relative block rounded bg-gray-black w-full border-none text-sm text-white"
                            classString="w-full shadow"
                            @change="validateFields(['businessBrandProfileId'])"
                        />
                        <p class="field-error label-text mt-1" v-if="form.businessBrandProfileId.error_message" v-text="form.businessBrandProfileId.error_message"></p>
                    </div>
                </div>
            </div>
            <div class="flex gap-3 xl:flex-row flex-col items-start mb-3">
                <div class="w-full xl:w-1/2">
                    <div :class="'input-wrapper ' + (form.slug.error_type)">
                        <label class="text-xs mb-1">Location Slug</label>
                        <input placeholder="North-York" v-model="form.slug.value" @keyup="validateFields(['slug'])" class="block border-none rounded bg-gray-black w-full text-sm text-white placeholder-borderblack" type="text">
                        <p class="field-error label-text mt-1" v-if="form.slug.error_message" v-text="form.slug.error_message"></p>
                    </div>
                </div>
                <div class="w-full xl:w-1/2">
                    <div :class="'input-wrapper ' + (form.phone.error_type)">
                        <label class="text-xs mb-1">Phone</label>
                        <input placeholder="416-124-1353" v-model="form.phone.value" @keyup="validateFields(['phone'])" @input="acceptNumber" class="block border-none rounded bg-gray-black w-full text-sm text-white placeholder-borderblack" type="text">
                        <p class="field-error label-text mt-1" v-if="form.phone.error_message" v-text="form.phone.error_message"></p>
                    </div>
                </div>
            </div>
            <div class="flex gap-3 xl:flex-row flex-col items-start mb-3">
                <div class="w-full xl:w-1/2">
                    <div :class="'input-wrapper ' + (form.email.error_type)">
                        <label class="text-xs mb-1">Email</label>
                        <input placeholder="Email@address.com" v-model="form.email.value" @keyup="validateFields(['email'])" class="block border-none rounded bg-gray-black w-full text-sm text-white placeholder-borderblack" type="text">
                        <p class="field-error label-text mt-1" v-if="form.email.error_message" v-text="form.email.error_message"></p>
                    </div>
                </div>
                <div class="w-full xl:w-1/2">
                    <div :class="'input-wrapper ' + (form.licenseId.error_type)">
                        <label class="text-xs mb-1">Retail License Number</label>
                        <input placeholder="1231114314324" v-model="form.licenseId.value"  class="block border-none rounded bg-gray-black w-full text-sm text-white placeholder-borderblack" type="text">
                        <p class="field-error label-text mt-1" v-if="form.licenseId.error_message" v-text="form.licenseId.error_message"></p>
                    </div>
                </div>
            </div>
            <div class="flex gap-3 xl:flex-row flex-col items-start mb-3">
                <div class="w-full xl:w-1/2">
                    <div :class="'input-wrapper ' + (form.internalId.error_type)">
                        <label class="text-xs mb-1">Tax ID</label>
                        <input placeholder="1231114314324" @keyup="validateFields(['internalId'])" v-model="form.internalId.value" class="block border-none rounded bg-gray-black w-full text-sm text-white placeholder-borderblack" type="text">
                        <p class="field-error label-text mt-1" v-if="form.internalId.error_message" v-text="form.internalId.error_message"></p>
                    </div>
                </div>
                <div class="w-full xl:w-1/2">
                    <div :class="'input-wrapper ' + (form.timezone.error_type)">
                        <label class="text-xs mb-1">Timezone</label>
                        <div class="relative">
                            <select v-model="form.timezone.value" @change="validateFields(['timezone'])" class="block border-none rounded bg-gray-black w-full text-sm text-white placeholder-borderblack">
                              <option value="">--Select--</option>
                              <option v-bind:key="timeZone" :value="key" v-for="(timeZone, key) in timeZones">{{ timeZone }}</option>
                            </select>
                        </div>
                        <p class="field-error label-text mt-1" v-if="form.timezone.error_message" v-text="form.timezone.error_message"></p>
                    </div>
                </div>
            </div>
            <div class="flex gap-3 xl:flex-row flex-col items-start mb-3">
              <div class="w-full xl:w-1/2" @click.prevent="toggle()">
                  <div class="flex flex-col">
                    <div class="text-xs">Active</div>
                    <label class="flex items-center cursor-pointer mt-2">
                      <input type="checkbox" v-model="form.active" class="hidden peer">
                      <div :class="'relative toggle-bg  border-2  h-6 w-11 rounded-full ' + (form.active ? 'bg-theme-green border-theme-green' : 'bg-[#F53333] border-[#F53333]')"></div>
                      <span class="ml-2 text-white text-sm font-medium uppercase" :class="form.active ? 'text-theme-green' : 'text-[#F53333]'">{{form.active ? 'On' : 'Off'}}</span>
                    </label>
                  </div>
                </div>
            </div>
            <div class="bg-theme-borderblack h-1 w-full my-4"></div>
            <div class="flex gap-3 xl:flex-row flex-col items-start mb-3">
                <div class="w-full xl:w-1/2">
                    <div :class="'input-wrapper ' + (form.address1.error_type)">
                        <label class="text-xs mb-1">Address Line 1</label>
                        <input
                          type="text"
                          placeholder="Search Address"
                          id="address1"
                          @keyup="resetPlace"
                          class="block border-none rounded bg-gray-black w-full text-sm text-white py-2 px-2 placeholder-borderblack focus:ring-transparent focus:outline-none"
                        />
                        <p class="field-error label-text mt-1" v-if="form.address1.error_message" v-text="form.address1.error_message"></p>
                    </div>
                </div>
                <div class="w-full xl:w-1/2">
                    <div class="input-wrapper">
                        <label class="text-xs mb-1">Address Line 2</label>
                        <input placeholder="Optional" v-model="form.address2" class="block border-none rounded bg-gray-black w-full text-sm text-white" type="text">
                    </div>
                </div>
            </div>
            <div class="flex gap-3 xl:flex-row flex-col items-start mb-3">
                <div class="w-full xl:w-1/2">
                    <div :class="'input-wrapper ' + (form.city.error_type)">
                        <label class="text-xs mb-1">City</label>
                        <input placeholder="Toronto" @keyup="validateFields(['city'])" v-model="form.city.value" class="block border-none rounded bg-gray-black w-full text-sm text-white placeholder-borderblack" type="text">
                        <p class="field-error label-text mt-1" v-if="form.city.error_message" v-text="form.city.error_message"></p>
                    </div>
                </div>
                <div class="w-full xl:w-1/2">
                    <div :class="'input-wrapper ' + (form.province.error_type)">
                        <label class="text-xs mb-1">Province</label>
                        <input placeholder="Ontario" @keyup="validateFields(['province'])" v-model="form.province.value" class="block border-none rounded bg-gray-black w-full text-sm text-white placeholder-borderblack" type="text">
                        <p class="field-error label-text mt-1" v-if="form.province.error_message" v-text="form.province.error_message"></p>
                    </div>
                </div>
            </div>
            <div class="flex gap-3 xl:flex-row flex-col items-start mb-3">
                <div class="w-full xl:w-1/2">
                    <div :class="'input-wrapper ' + (form.postalCode.error_type)">
                        <label class="text-xs mb-1">Postal Code</label>
                        <input placeholder="L2C 1J1" @keyup="validateFields(['postalCode'])" v-model="form.postalCode.value" class="block border-none rounded bg-gray-black w-full text-sm text-white placeholder-borderblack" type="text">
                        <p class="field-error label-text mt-1" v-if="form.postalCode.error_message" v-text="form.postalCode.error_message"></p>
                    </div>
                </div>
                <div class="w-full xl:w-1/2">
                    <div :class="'input-wrapper ' + (form.country.error_type)">
                        <label class="text-xs mb-1">Country</label>
                        <input placeholder="Canada" @keyup="validateFields(['country'])" v-model="form.country.value" class="block border-none rounded bg-gray-black w-full text-sm text-white placeholder-borderblack" type="text">
                        <p class="field-error label-text mt-1" v-if="form.country.error_message" v-text="form.country.error_message"></p>
                    </div>
                </div>
            </div>

        </div>
      </template>
    </div>
  </div>
</template>


<script>
import  { defineComponent , HtmlHTMLAttributes, ref} from "vue";
import { mapGetters, mapActions, mapMutations } from "vuex";
import Env from '@/env';
import Helpers from '@/helpers';
import LocationInfoApis from '@/controllers/LocationInfoApis';
import BrandingProfileApis from '@/controllers/BrandingProfileApis';
import SelectSearchBrand from '@/components/form/SelectSearchBrand';


export default defineComponent({
  name: "LocationInfoIndex",
  components: {
    SelectSearchBrand,
  },
  setup() {
    const domain = ref('')
    const businessProfiles = ref([]);
    const form = ref({
        name:  {
          value: '',
          error_type: '',
          error_message: '',
          validations: ['required', 'min:2'],
        },
        businessBrandProfileId: {
          value: '',
          error_type: '',
          error_message: '',
          validations: [],
        },
        slug: {
          value: '',
          error_type: '',
          error_message: '',
          validations: ['required', 'min:2'],
        },
        licenseId: {
          value: '',
          error_type: '',
          error_message: '',
          validations: [],
        },
        corporate: true,
        internalId: {
          value: '',
          error_type: '',
          error_message: '',
          validations: ['required', 'min:3'],
        },
        address1: {
          value: '',
          error_type: '',
          error_message: '',
          validations: ['required'],
        },
        address2: '',
        city: {
          value: '',
          error_type: '',
          error_message: '',
          validations: ['required', 'min:3'],
        },
        postalCode: {
          value: '',
          error_type: '',
          error_message: '',
          validations: ['required', 'min:3'],
        },
        country: {
          value: '',
          error_type: '',
          error_message: '',
          validations: ['required'],
        },
        timezone: {
           value: '',
          error_type: '',
          error_message: '',
          validations: ['required'],
        },
        active: false,
        lat: '',
        long: '',
        phone: {
          value: '',
          error_type: '',
          error_message: '',
          validations: ['required', 'phone'],
        },
        email: {
          value: '',
          error_type: '',
          error_message: '',
          validations: ['required', 'email'],
        },
        province:  {
          value: '',
          error_type: '',
          error_message: '',
          validations: ['required'],
        },
    });
    const watchCount = ref(1);
    const loading = ref(false);
    const autocomplete = ref({})
    return {
      domain,
      watchCount,
      loading,
      form,
      autocomplete,
      businessProfiles,
    };
  },

  computed: {
    can_edit_business_brand_profiles() {
      return Helpers.getMyPermission('can_edit_business_brand_profiles')
    },
    timeZones() {
      return Env.timeZones;
    },
    webStoreUrl() {
      return Env.webStoreUrl;
    },
    ...mapGetters({
      vg_selectedLocation: 'location/selected',
      vg_activeBusiness: 'auth/activeBusiness',
    }),
    
  },

  watch: {
    'form.businessBrandProfileId.value'(current, prev){
      if(current === null){
        this.confirmNew('Warning!', 'Are you sure you want to disable this location?', 'Yes', 'bg-theme-red text-white').then(result => {
          if(result){
            this.form.businessBrandProfileId.value = null;
          }
        }).catch((err) =>{
          this.form.businessBrandProfileId.value = prev
        })
      }
    },
    'form.slug.value'(val) {
      if(val) {
        val = val.toLowerCase();
        val = val.replaceAll(/\s/g,'').trim();
        this.form.slug.value = val;
      } else {
        this.form.slug.value = '';
      }
    },
    'form.phone.value'(val) {
      if(val){
        let newval = val.toString();
        this.form.phone.value = newval;
      }
    },
    'form.province.value'() {
      // do not validate when the data is assign on mount
      if(this.watchCount > 1){
        this.validateFields(['province']);
      }
    },
    'form.city.value'() {
      if(this.watchCount > 1){
        this.validateFields(['city']);
      }
    },
    'form.postalCode.value'() {
      if(this.watchCount > 1){
        this.validateFields(['postalCode']);
      }
    },
    'form.country.value'() {
      if(this.watchCount > 1){
        this.validateFields(['country']);
      }
    },

    'vg_selectedLocation': async function() {
      this.initGoogle()
      this.watchCount = 1;
      this.loading = true;
      await this.fetchLocationInfo()
      this.loading = false;
    },
  },

  async mounted() {
    this.initGoogle()
    this.watchCount = 1;
    this.fetchBusinessProfiles();
    this.fetchLocationInfo();
    this.emitter.on("validate-location-info", data => {
      this.validateFieldsAndReturnData();
    });
  },

  beforeDestroy() {
   this. emitter.off('validate-location-info', () => {})
  },

  methods: {
    initGoogle(){
      const self = this;
      // need to load dom before execute so need to add 1 s time
      setTimeout(async () => {
        let ele = document.getElementById("address1");
        // const loader = new Loader({
        //   apiKey: 'AIzaSyBJs2f0TNNui_OcRHgVRTIsJAvGQ0EB7oA',
        //   libraries: ["drawing", "places"]
        // });

        this._gloader
        .load()
        .then((google) => {
          self.autocomplete = new google.maps.places.Autocomplete(ele, {
            componentRestrictions: { country: "ca" }

          });
          self.autocomplete.addListener('place_changed', self.setPlace)
        })
        .catch(e => {
          console.log(e)
          // do something
        });

      }, 3000)
    },
    toggle(){
      this.form.active = !this.form.active
    },
    /**
     * Fetch business branding profiles (like General/Profiles/Index.vue)
     */
    async fetchBusinessProfiles() {
      try {
        const res = await BrandingProfileApis.fetchBusinessBrandingProfile();
        if (res?.status === 200 && Array.isArray(res?.data?.payload)) {
          this.businessProfiles = res.data.payload;
        } else {
          this.businessProfiles = [];
        }
      } catch (error) {
        this.businessProfiles = [];
      }
    },
    acceptNumber() {
        var x = this.form.phone.value.replace(/\D/g, '').match(/(\d{0,3})(\d{0,3})(\d{0,4})/);
        this.form.phone.value = !x[2] ? x[1] : '(' + x[1] + ')-' + x[2] + (x[3] ? '-' + x[3] : '');
    },
    

    /**
     * Fetch location info
     */
    async fetchLocationInfo( reset = false) {
      this.loading = true;
      let params = `includeBusinessBrandProfile=1`;
      let res = await LocationInfoApis.fetchLocationInfo(params);
      if(res.status == 200) {
        this.form = await Helpers.assignFormValuesOnlyPayload(this.form, res.data.payload);
        this.form.businessBrandProfileId.value = res.data.payload.businessBrandProfile?.id;
        this.domain = res.data.payload.businessBrandProfile?.domain
      } else {
        this.form = await Helpers.assignFormValuesOnlyPayload(this.form, {});
      }
      this.loading = false;
      this.$nextTick(() => {
        let address1ID = document.getElementById('address1');
        address1ID.value = this.form?.address1?.value;
      });
      this.watchCount = 2;
    },

    /**
     * Validates form fields and return the data to push on Api
     */
    async validateFieldsAndReturnData() {
      let validate = await this.validateFields(['name', 'businessBrandProfileId', 'slug',  'internalId', 'address1', 'city', 'province', 'postalCode', 'country', 'timezone', 'phone', 'email']);
      if(!validate) {
        return ;
      }
      let data = await Helpers.getFormKeyValue(this.form);
      data.phone = data.phone.toString(); // conver phone to string
      data.address2 = data.address2 ? data.address2 : null; // need to pass null instead of empty string
      this.emitter.emit("location-info-submit", data);
    },

    /**
     * Validation captures
     */
    async validateFields(fields) {
      let res = await Helpers.validateFormFields(this.form, fields);
      this.form = res.data;
      return res.error ? false : true;
    },

    async resetPlace() {
     let address1ID = document.getElementById('address1');
      if (address1ID.value == undefined || address1ID.value == '') {
        this.form.postalCode.value = '';
        this.form.province.value = '';
        this.form.city.value = '';
        this.form.country.value  = '';
        this.form.active = false;
        this.form.lat = '';
        this.form.long = '';
        this.form.address1.value = ''; //vue bind
        await this.validateFields(['name', 'slug', 'internalId', 'address1', 'city', 'province', 'postalCode', 'country', 'timezone', 'phone', 'email']);
      }
    },

    /**
     * Set place
     */
    setPlace() {
      
      let addressData = this.autocomplete.getPlace();
      this.form.address1.value = addressData.name;
      let address1 = document.getElementById('address1');
      address1.value = addressData.name; // for element
      this.form.address1.value = addressData.name; // vue bind
      this.form.address2 = addressData.vicinity
      this.validateFields(['address1']);
      this.form.postalCode.value = Helpers.getDetailFromGmapAutoComplete(addressData.address_components, 'postal_code');
      this.form.province.value = Helpers.getDetailFromGmapAutoComplete(addressData.address_components, 'administrative_area_level_1') ? Helpers.getDetailFromGmapAutoComplete(addressData.address_components, 'administrative_area_level_1', 'short_name') : Helpers.getDetailFromGmapAutoComplete(addressData.address_components, 'administrative_area_level_2', 'short_name');
      this.form.city.value = Helpers.getDetailFromGmapAutoComplete(addressData.address_components, 'locality');
      this.form.country.value  = Helpers.getDetailFromGmapAutoComplete(addressData.address_components, 'country', 'long_name');
      let lat;
      let long;
      if (typeof addressData.geometry.location.lat === 'function') {
        lat = addressData.geometry.location.lat();
        long = addressData.geometry.location.lng();
      } else {
        lat = addressData.geometry.location.lat;
        long = addressData.geometry.location.lng;
      }
      this.form.lat = lat;
      this.form.long = long;
    },

    getUrl(){
      let url
      if(this.domain){
          url = this.domain+'/'+this.vg_selectedLocation.slug+'/'
      }else{
          url = 'No Domain Set Yet'
      }
      return url
    },
    getDomainUrl(){
      if(this.domain.includes('https://')){
        return this.domain+'/'+this.vg_selectedLocation.slug+'/'
      }else{
        return 'https://'+this.domain+'/'+this.vg_selectedLocation.slug+'/'
      }
    },

    ...mapActions({
      va_spinner: "spinner/setSpinner",
    })
  }
});
</script>



